import React from 'react';
import ActionsCurrent from './ActionsCurrent';
import ActionsPast from './ActionsPast';

/**
 * (dyouberg) This component represents the Select Actions dropdowns for the ReactTable,
 * aka the final table.  There is a lot of business logic in this file and it's children -
 * so I'm hoping this makes things just a tad bit easier to comprehend and modify
 * in the future.
 */
const AuctionGroupActions = (groupID, handleDeleteSession, houseID, houseRef, live, type) => (type === 'current'
  ? {
    Header: 'Actions',
    // Must match the value in AuctionGroupColumns.jsx
    id: 'AuctionGroupActions',
    sortable: false,
    width: 265,
    accessor: d => d,
    Cell: ({ value }) => {
      if (!value) {
        return null;
      }

      return (
        <ActionsCurrent
          groupID={groupID}
          handleDeleteSession={handleDeleteSession}
          houseID={houseID}
          live={live}
          values={value}
        />
      );
    }
  }
  : {
    Header: 'Actions',
    id: 'actions',
    sortable: false,
    accessor: d => d,
    Cell: ({ value }) => {
      if (!value) {
        return null;
      }
      return <ActionsPast values={value} houseRef={houseRef}/>;
    }
  });

export default AuctionGroupActions;
